export default __webpack_public_path__ + "static/media/captain-america.6703250d.png";